import { lazy, type ComponentType } from "react";

const CHUNK_RELOAD_KEY = "__chunk_reload_attempted_at__";
const CHUNK_ERROR_PATTERN =
  /Importing a module script failed|Failed to fetch dynamically imported module|ChunkLoadError|Loading chunk \d+ failed|error loading dynamically imported module/i;

export function reloadOnceForChunkError(message: string) {
  if (!CHUNK_ERROR_PATTERN.test(message)) return;

  const lastAttempt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
  if (Number.isFinite(lastAttempt) && Date.now() - lastAttempt < 30_000) return;

  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  window.location.reload();
}

export function lazyWithRecovery<T extends ComponentType<unknown>>(
  importer: () => Promise<{ default: T }>,
) {
  return lazy(async () => {
    try {
      return await importer();
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      reloadOnceForChunkError(message);
      throw error;
    }
  });
}